@if (!isLoading) {
  <!-- portfolio header -->
  <pwj-portfolio-header [headerData]="headerData"></pwj-portfolio-header>

  <!-- portfolio content -->
  <main>
    <!-- hero section -->
    <pwj-hero-section
      [heroData]="heroData"
      [contactInfo]="contactInfo"></pwj-hero-section>
    <!-- about form section -->
    <pwj-about-section [aboutData]="aboutData"></pwj-about-section>

    <!-- company video section -->
    @if (companyVideo?.video_urls) {
      <pwj-company-vision-section
        class="container"
        [companyVideoData]="companyVideo"></pwj-company-vision-section>
    }

    <!-- portfolio products -->
    <pwj-top-products-section
      class="container"
      [isPortfolioMode]="true"
      [topProducts]="topProducts"
      [productsCount]="businessProductsCount"
      [productsLoading]="isBusinessProductsLoading"></pwj-top-products-section>

    <!-- members section -->
    <pwj-team-members-section
      class="container"
      [membersData]="membersData"></pwj-team-members-section>

    <!-- contact form section -->
    <pwj-contact-section
      class="container"
      [businessId]="businessId"
      [showTab]="false"
      [isPortfolioMode]="true"></pwj-contact-section>

    <!-- explore section -->
    <!-- <pwj-explore-section [isPortfolioMode]="true"></pwj-explore-section> -->
  </main>

  <!-- portfolio footer -->
  <pwj-portfolio-footer [footerData]="footerData"></pwj-portfolio-footer>

  <!-- chat box component -->
  <pwj-chat-box></pwj-chat-box>
} @else {
  <!-- portfolio skeleton component -->
  <pwj-portfolio-skeleton></pwj-portfolio-skeleton>
}
